import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const ChairIcon = (props: IconProps) => (
  <StyledIcon
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M4 19V21C4 21.2652 4.10536 21.5196 4.29289 21.7071C4.48043 21.8946 4.73478 22 5 22C5.26522 22 5.51957 21.8946 5.70711 21.7071C5.89464 21.5196 6 21.2652 6 21V19H4Z"
      fill="currentColor"
    />
    <path
      d="M18 19V21C18 21.2652 18.1054 21.5196 18.2929 21.7071C18.4804 21.8946 18.7348 22 19 22C19.2652 22 19.5196 21.8946 19.7071 21.7071C19.8946 21.5196 20 21.2652 20 21V19H18Z"
      fill="currentColor"
    />
    <path
      d="M22 12H2C1.46957 12 0.960859 12.2107 0.585786 12.5858C0.210714 12.9609 0 13.4696 0 14L0 23C0 23.2652 0.105357 23.5196 0.292893 23.7071C0.48043 23.8946 0.734784 24 1 24C1.26522 24 1.51957 23.8946 1.70711 23.7071C1.89464 23.5196 2 23.2652 2 23V18H22V23C22 23.2652 22.1054 23.5196 22.2929 23.7071C22.4804 23.8946 22.7348 24 23 24C23.2652 24 23.5196 23.8946 23.7071 23.7071C23.8946 23.5196 24 23.2652 24 23V14C24 13.4696 23.7893 12.9609 23.4142 12.5858C23.0391 12.2107 22.5304 12 22 12Z"
      fill="currentColor"
    />
    <path
      d="M21 10V3C21 2.20435 20.6839 1.44129 20.1213 0.87868C19.5587 0.31607 18.7956 0 18 0L6 0C5.20435 0 4.44129 0.31607 3.87868 0.87868C3.31607 1.44129 3 2.20435 3 3V10H21Z"
      fill="currentColor"
    />
  </StyledIcon>
)
